import { CoreModule } from '@core/core.module';
import { Module } from '@rxdi/core';
import { RouterModule } from '@rxdi/router';
import { SharedModule } from '@shared/shared.module';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';

@Module({
  components: [NavbarComponent, HomeComponent, FooterComponent],
  imports: [
    SharedModule,
    CoreModule,
    RouterModule.forRoot(
      [
        {
          path: '/',
          component: HomeComponent,
        },
        {
          path: '/flex',
          children: () => import('./flex/flex.module'),
        },

        {
          path: '/blog',
          children: () => import('./blog/blog.module'),
        },
        {
          path: '/login',
          children: () => import('./login/login.module'),
        },
        {
          path: '(.*)',
          component: 'not-found-component',
          action: () => import('./not-found/not-found.component'),
        },
      ],
      { log: true }
    ),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
